import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TdiIntroComponent } from './tdi-intro/tdi-intro.component';
import { TdiQuoteComponent } from './tdi-quote/tdi-quote.component';
import { TdiOptimizeComponent } from './tdi-optimize/tdi-optimize.component';
import { TdiStrugglesComponent } from './tdi-struggles/tdi-struggles.component';
import { TdiHowWorksComponent } from './tdi-how-works/tdi-how-works.component';
import { TdiBenefitsComponent } from './tdi-benefits/tdi-benefits.component';

@Component({
  selector: 'app-tdi-landing-page',
  templateUrl: './tdi-landing-page.component.html',
  styleUrls: ['./tdi-landing-page.component.scss'],
  imports: [
    TdiIntroComponent,
    TdiQuoteComponent,
    TdiOptimizeComponent,
    TdiStrugglesComponent,
    TdiHowWorksComponent,
    TdiBenefitsComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TdiLandingPageComponent {}
